import {
    AUTH, MESSAGE
  } from "./types/types";
  
  import AuthService from "../../services/auth.service";
  
  export const registerAuth = (data) => (dispatch) => {
    return AuthService.register(data).then(
      (response) => {
        dispatch({
          type: AUTH.REGISTER_SUCCESS,
        });
  
        dispatch({
          type: MESSAGE.SET_MESSAGE,
          payload: response.data.message,
        });
        
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: AUTH.REGISTER_FAIL,
        });
  
        dispatch({
          type:  MESSAGE.SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };
  
  export const GetUserRole = () => (dispatch) => {
    return AuthService.getUserRole().then(
      (data) => {
        dispatch({
          type: AUTH.USER_INFORMATION,
          payload: { user : data },
        });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: AUTH.LOGIN_FAIL,
        });
  
        dispatch({
          type: MESSAGE.SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };

  export const login = (username, password) => (dispatch) => {
    return AuthService.login(username, password).then(
      (data) => {
        dispatch({
          type: AUTH.LOGIN_SUCCESS,
          payload: { token: data },
        });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: AUTH.LOGIN_FAIL,
        });
  
        dispatch({
          type: MESSAGE.SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };


  export const recoveryPassword = (username) => (dispatch) => {
    return AuthService.recoveryPassword(username).then(
      (data) => {
        dispatch({
          type: AUTH.RECOVERY_SUCCESS,
        });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: AUTH.LOGIN_FAIL,
        });
  
        dispatch({
          type: MESSAGE.SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };

  export const resetPassword = (form) => (dispatch) => {
    return AuthService.resetPassword(form).then(
      (data) => {
        dispatch({
          type: AUTH.RESETPASSWORD_SUCCESS,
        });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: AUTH.LOGIN_FAIL,
        });
  
        dispatch({
          type: MESSAGE.SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };

  export const loginToken = (email, appkey) => (dispatch) => {
    return AuthService.loginWithToken(email, appkey).then(
      (data) => {
        dispatch({
          type: AUTH.LOGIN_SUCCESS,
          payload: { token: data },
        });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: AUTH.LOGIN_FAIL,
        });
  
        dispatch({
          type: MESSAGE.SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };

  export const registerUserApprover = (data) => (dispatch) => {
    return AuthService.registerUserApprover(data).then(
      (response) => {
        dispatch({
          type: AUTH.REGISTER_USER_APPROVER_SUCCESS,
        });
  
        dispatch({
          type: MESSAGE.SET_MESSAGE,
          payload: response.data.message,
        });
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type:AUTH.REGISTER_USER_APPROVER_FAIL,
        });
  
        dispatch({
          type: MESSAGE.SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };
  
  export const logout = () => (dispatch) => {
    AuthService.logout();
    dispatch({
      type: AUTH.LOGOUT,
    });
  };
  
